/* eslint-disable react-hooks/exhaustive-deps */
import Dropdown from "../../components/Dropdown/Dropdown";
import InputText from "../../components/InputText/InputText";
import InputNumber from "../../components/InputNumbers/InputNumber";
import Comment from "../../components/Comment/Comment";
import React, { useState, useEffect } from "react";
import { FormikProps, useFormik } from "formik";
import * as Yup from "yup";
import * as types from "../../redux/Action/actionTypes";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/Reducer";
import {
  getCountriesDropdownAction,
  getCatagoriesDropdownAction,
  getSuppliersDropdownAction,
  saveBasicDetails,
  getPowerPositionList,
  getSalesRepClassificationList,
} from "../../redux/Action/Action";
import ModalComponent from "../../components/Modal/modal";
import { monthOptions } from "../../utils/content";
import TableView from "../../components/TableView/TableView";
import PeoplePicker from "../../components/PeoplePicker/PeoplePicker";
import MultiSelecetDropdown from "../../components/MultiSelectDropdown/MultiSelectDropdown";

interface BasicDetailsProps {
  setIsNextDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  setRefInstance: (instance: FormikProps<any> | null) => void;
}

interface InitialValues {
  negotiationName: string;
  leadCountry: string;
  categoryName: string;
  categoryCode: string;
  cluster: string;
  negotiationTeam: string;
  od: string;
  suppliers: string;
  supplierLocation: string;
  salesRepLead: string;
  additionalSalesRep: string;
  negotiationDateMonth: string;
  negotiationDateYear: string;
  negotiationImplementationMonth: string;
  negotiationImplementationYear: string;
  validityPeriod: number;
  relevantSpend: number;
  comment: string;
}
interface CategoryOption {
  id: string;
  name: string;
  categoryCode: string;
  cluster: string;
  status: boolean;
}
interface SupplierOption {
  value: string;
  name: string;
  address: string;
  supplierLocation: string;
}
interface SalesRepLeadOption {
  supplierID: string;
  name: string;
  emailAddress: string;
  mobileNumber: string;
}
const BasicDetails = ({
  setIsNextDisabled,
  setRefInstance,
}: BasicDetailsProps) => {
  const dispatch = useDispatch();
  const [isExitClick, setIsExitClick] = useState<boolean>(false);
  const [HasShownHighSpendModal, setHasShownHighSpendModal] =
    useState<boolean>(false);
  const basicDetailsData = useSelector(
    (state: RootState) => state.basicDetails.basicDetailsData
  );
  const countriesData = useSelector(
    (state: RootState) => state.basicDetails.countriesData
  );
  const catagoriesData = useSelector(
    (state: RootState) => state.basicDetails.catagoriesData
  ) as CategoryOption[];
  const suppliersData = useSelector(
    (state: RootState) => state.basicDetails.suppliersData
  ) as SupplierOption[];
  const salesRepLeadData = useSelector(
    (state: RootState) => state.basicDetails.salesRepLeadData
  );
  const [SelectedSupplierName, setSelectedSupplierName] = useState<string>("");

  const supplierColumns: {
    key: keyof SupplierOption;
    label: string;
    sortable: boolean;
  }[] = [
    { key: "name", label: "Name", sortable: true },
    { key: "supplierLocation", label: "Location", sortable: true },
  ];

  const salesRepLeadColumns: {
    key: keyof SalesRepLeadOption;
    label: string;
    sortable: boolean;
  }[] = [
    { key: "name", label: "Name", sortable: true },
    { key: "emailAddress", label: "Email Address", sortable: true },
    { key: "mobileNumber", label: "Mobile Number", sortable: true },
  ];

  const handleDeleteSalesRep = (salesRepId: string) => {
    const removeSalesRepLead = {
      ID: salesRepId,
      Status: false,
    };
    dispatch({
      type: types.DELETE_SALES_REP_LEAD,
      payload: { removeSalesRepLead },
    });
    if (formik.values.salesRepLead === salesRepId) {
      formik.setFieldValue("salesRepLead", "");
    }
    if (formik.values.additionalSalesRep === salesRepId) {
      formik.setFieldValue("additionalSalesRep", "");
    }
  };

  const handleDeleteSupplier = (supplierId: string) => {
    const removeSupplier = {
      ID: supplierId,
      Status: false,
    };
    dispatch({ type: types.DELETE_SUPPLIER, payload: { removeSupplier } });
    if (formik.values.suppliers === supplierId) {
      formik.setFieldValue("supplierLocation", "");
      formik.setFieldValue("suppliers", "");
      formik.setFieldValue("salesRepLead", "");
      formik.setFieldValue("additionalSalesRep", "");
    }
    dispatch({ type: types.CREATE_NEW_SALES_REP_LEAD_FAILURE });
  };

  const initialValues: InitialValues = {
    negotiationName: "",
    leadCountry: "",
    categoryName: "",
    categoryCode: "",
    cluster: "",
    negotiationTeam: "",
    od: "",
    suppliers: "",
    supplierLocation: "",
    salesRepLead: "",
    additionalSalesRep: "",
    negotiationDateMonth: "",
    negotiationDateYear: "",
    negotiationImplementationMonth: "",
    negotiationImplementationYear: "",
    validityPeriod: 0,
    relevantSpend: 0,
    comment: "",
  };

  const validationSchema = Yup.object({
    negotiationName: Yup.string()
      .trim()
      .max(100, "Maximum 100 characters allowed")
      .required("Negotiation name is required"),
    leadCountry: Yup.string().trim().required("Lead country is required"),
    categoryName: Yup.string().trim().required("Category name is required"),
    categoryCode: Yup.string().trim(),
    cluster: Yup.string().trim(),
    negotiationTeam: Yup.string(),
    od: Yup.string().trim().max(50, "Maximum 50 characters allowed"),
    suppliers: Yup.string().trim().required("Supplier is required"),
    supplierLocation: Yup.string()
      .trim()
      .required("Supplier location is required"),
    salesRepLead: Yup.string().trim().required("Sales rep lead is required"),
    additionalSalesRep: Yup.string().trim(),
    negotiationDateMonth: Yup.string().trim().required("Month is required"),
    negotiationDateYear: Yup.string().trim().required("Year is required"),
    negotiationImplementationMonth: Yup.string()
      .trim()
      .required("Month is required"),
    negotiationImplementationYear: Yup.string()
      .trim()
      .required("Year is required"),
    validityPeriod: Yup.number()
      .required("Validity period is required")
      .min(1, "Value should be between 1 to 999")
      .max(999, "Value should be between 1 to 999")
      .test(
        "max-decimals",
        "Value can be upto 1 decimal",
        (value) => value === undefined || /^\d+(\.\d)?$/.test(value.toString())
      ),
    relevantSpend: Yup.number()
      .required("Relevant spend is required")
      .min(1, "Value should be between 1 to 999999999999")
      .max(999999999999, "Value should be between 1 to 999999999999")
      .test(
        "max-decimals",
        "Maximum 2 decimal places allowed",
        (value) =>
          value === undefined || /^\d+(\.\d{1,2})?$/.test(value.toString())
      ),
    comment: Yup.string().trim().max(1000, "Maximun 1000 characters allowed"),
  });

  const yearOptions = Array.from({ length: 26 }, (_, i) =>
    (2024 + i).toString()
  );
  const exitConfirmHandler = () => {
    setIsExitClick(false);
  };

  const cancelBtnHandler = () => {
    setIsExitClick(false);
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnMount: true,
    onSubmit: (data) => {
      dispatch(saveBasicDetails(data));
    },
  });

  const additionalSalesRepOptions = salesRepLeadData?.filter(
    (rep: any) => rep.value !== formik.values.salesRepLead
  );

  useEffect(() => {
    if (Object.keys(formik.errors).length === 0) {
      setIsNextDisabled(false);
    } else {
      setIsNextDisabled(true);
    }
  }, [formik]);

  useEffect(() => {
    formik.setValues({ ...formik.values, ...basicDetailsData });
  }, []);

  useEffect(() => {
    const selectedCategory = catagoriesData.find(
      (cat: any) => cat.value === formik.values.categoryName
    );

    if (selectedCategory) {
      formik.setFieldValue("cluster", selectedCategory.cluster || "");
      formik.setFieldValue("categoryCode", selectedCategory.categoryCode || "");
    }
  }, [formik.values.categoryName, catagoriesData]);

  useEffect(() => {
    const selectedSupplier = suppliersData?.find(
      (supplier: any) => supplier.value === formik.values.suppliers
    );
    setSelectedSupplierName(selectedSupplier?.name ?? "");

    if (selectedSupplier) {
      formik.setFieldValue(
        "supplierLocation",
        selectedSupplier.supplierLocation || ""
      );

      dispatch({
        type: types.GET_BASIC_DETAILS_SALESREPLEAD,
        payload: selectedSupplier.value,
      });
    } else {
      dispatch({ type: types.CREATE_NEW_SALES_REP_LEAD_FAILURE });
      formik.setFieldValue("supplierLocation", "");
    }
  }, [formik.values.suppliers, suppliersData]);

  useEffect(() => {
    dispatch(getCountriesDropdownAction());
    dispatch(getCatagoriesDropdownAction());
    dispatch(getSuppliersDropdownAction());
    dispatch(getPowerPositionList());
    dispatch(getSalesRepClassificationList());
  }, []);

  useEffect(() => {
    setRefInstance(formik);
  }, [formik]);

  useEffect(() => {
    const spend = formik.values.relevantSpend;
    if (spend > 5000000 && !HasShownHighSpendModal) {
      setIsExitClick(true);
      setHasShownHighSpendModal(true);
    } else if (spend <= 5000000 && HasShownHighSpendModal) {
      setHasShownHighSpendModal(false);
    }
  }, [formik.values.relevantSpend]);

  return (
    <div className="FormPage">
      <form>
        <div className="form-container">
          <div className="Form-grid">
            <InputText
              label="* Negotiation name"
              {...formik.getFieldProps("negotiationName")}
              error={formik.errors.negotiationName}
              touched={formik.touched.negotiationName}
              formik={formik}
            />
            <Dropdown
              label="* Lead country"
              name="leadCountry"
              placeholder=""
              options={countriesData}
              value={formik.values.leadCountry}
              touched={formik.touched.leadCountry}
              error={formik.errors.leadCountry}
              formik={formik}
            />
            <InputText
              label="OD"
              {...formik.getFieldProps("od")}
              error={formik.errors.od}
              touched={formik.touched.od}
              formik={formik}
            />
            <Dropdown
              label="* Category name"
              name="categoryName"
              options={catagoriesData}
              value={formik.values.categoryName}
              touched={formik.touched.categoryName}
              error={formik.errors.categoryName}
              formik={formik}
              placeholder=""
            />
            <InputText
              label="Cluster"
              {...formik.getFieldProps("cluster")}
              error={formik.errors.cluster}
              touched={formik.touched.cluster}
              formik={formik}
            />
            <InputText
              label="Category code"
              {...formik.getFieldProps("categoryCode")}
              error={formik.errors.categoryCode}
              touched={formik.touched.categoryCode}
              formik={formik}
            />
            <div className="basic-details-dropdown">
              <div style={{ width: "85%" }}>
                <Dropdown
                  label="* Suppliers"
                  name="suppliers"
                  options={suppliersData}
                  value={formik.values.suppliers}
                  touched={formik.touched.suppliers}
                  error={formik.errors.suppliers}
                  formik={formik}
                  placeholder=""
                />
              </div>
              <div className="new-supplier">
                <TableView
                  name="Suppliers"
                  Data={suppliersData?.map((s) => ({ ...s, Name: s.name }))}
                  columns={supplierColumns}
                  onDelete={handleDeleteSupplier}
                />
              </div>
            </div>

            <InputText
              label="* Location of the supplier"
              {...formik.getFieldProps("supplierLocation")}
              error={formik.errors.supplierLocation}
              touched={formik.touched.supplierLocation}
              formik={formik}
            />
            <div className="nego-date-grid">
              <div className="date-label">* Negotiation date</div>
              <div className="input-row">
                <Dropdown
                  name="negotiationDateMonth"
                  options={monthOptions}
                  placeholder="Month"
                  value={formik.values.negotiationDateMonth}
                  touched={formik.touched.negotiationDateMonth}
                  error={formik.errors.negotiationDateMonth}
                  label=""
                  formik={formik}
                />
                <Dropdown
                  name="negotiationDateYear"
                  options={yearOptions}
                  placeholder="Year"
                  value={formik.values.negotiationDateYear}
                  touched={formik.touched.negotiationDateYear}
                  error={formik.errors.negotiationDateYear}
                  label=""
                  formik={formik}
                />
              </div>
            </div>
            <div className="basic-details-dropdown">
              <div style={{ width: "85%" }}>
                <Dropdown
                  label="* Sales rep lead"
                  name="salesRepLead"
                  placeholder=""
                  options={salesRepLeadData}
                  value={formik.values.salesRepLead}
                  touched={formik.touched.salesRepLead}
                  error={formik.errors.salesRepLead}
                  formik={formik}
                />
              </div>
              <div className="new-supplier">
                <TableView
                  name="Sales rep lead"
                  Data={salesRepLeadData?.map((s: any) => ({
                    ...s,
                    Name: s.name,
                  }))}
                  columns={salesRepLeadColumns}
                  onDelete={handleDeleteSalesRep}
                  supplierID={formik.values.suppliers}
                  disabled={formik.values.suppliers === ""}
                  supplierName={SelectedSupplierName}
                />
              </div>
            </div>
            <MultiSelecetDropdown
              options={additionalSalesRepOptions}
              formik={formik}
              name="additionalSalesRep"
            />
            <div className="nego-date-grid">
              <div className="date-label">* Negotiation implementation</div>
              <div className="input-row">
                <Dropdown
                  name="negotiationImplementationMonth"
                  options={monthOptions}
                  placeholder="Month"
                  value={formik.values.negotiationImplementationMonth}
                  touched={formik.touched.negotiationImplementationMonth}
                  error={formik.errors.negotiationImplementationMonth}
                  label=""
                  formik={formik}
                />
                <Dropdown
                  name="negotiationImplementationYear"
                  options={yearOptions}
                  placeholder="Year"
                  value={formik.values.negotiationImplementationYear}
                  touched={formik.touched.negotiationImplementationYear}
                  error={formik.errors.negotiationImplementationYear}
                  label=""
                  formik={formik}
                />
              </div>
            </div>

            <InputNumber
              onBlur={formik.handleBlur}
              error={formik.errors.validityPeriod}
              touched={formik.touched.validityPeriod}
              label="* Validity period (in months)"
              name="validityPeriod"
              value={formik.values.validityPeriod}
              formik={formik}
            />

            <InputNumber
              onBlur={formik.handleBlur}
              error={formik.errors.relevantSpend}
              touched={formik.touched.relevantSpend}
              label="* Relevant spend in EUR"
              name="relevantSpend"
              value={formik.values.relevantSpend}
              formik={formik}
            />
            <div>
              <PeoplePicker name="negotiationTeam" formik={formik} />
            </div>
            <div className="full-width">
              <Comment
                onBlur={formik.handleBlur}
                error={formik.errors.comment}
                touched={formik.touched.comment}
                label="Comment"
                name="comment"
                value={formik.values.comment}
                formik={formik}
              />
            </div>
          </div>
        </div>
      </form>
      {
        <ModalComponent
          isOpen={isExitClick}
          modalTitle={"Confirmation"}
          toggle={cancelBtnHandler}
          modalBody="Buyer should attend a negotiation board meeting at least 8 weeks before the negotiation date"
          btnLeftHandler={exitConfirmHandler}
          btnLeftLabel={"Ok"}
          btnRightLabel=""
        />
      }
    </div>
  );
};

export default BasicDetails;
